export function loadJsonConfig(url) {
    return new Promise((resolve, reject) => {
        const xhttp = new XMLHttpRequest();
        xhttp.overrideMimeType('application/json');
        xhttp.onreadystatechange = function () {
            if (this.readyState === 4) {
                if (200 <= this.status && this.status <= 400) {
                    const jsonResponse = this.responseText;
                    const response = JSON.parse(jsonResponse);
                    resolve(response);
                }
                else {
                    reject('Could not load ' + url + ' file');
                }
            }
        };
        xhttp.open('GET', url, true);
        xhttp.send();
    });
}
//# sourceMappingURL=config.js.map